import { FC } from 'react'
import { List } from '@emotion-icons/fluentui-system-regular/List'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'
import { RootEntitiesTable } from 'src/v2/views/owner-reveal/insights/root-entities/table'
import { Colors } from 'src/components/theme'

const RootEntitiesContent: FC<InsightComponentProps> = ({ insight }) => {
  return (
    <InsightContainer
      insight={insight}
      contentWithoutSpacing
      color={Colors.primaryRed700}
      iconBgColor={Colors.primaryRed50}>
      <RootEntitiesTable />
    </InsightContainer>
  )
}

export const RootEntities: Insight = {
  id: 'root-entities',
  tabId: COMMANDAI_IDS_MAP.ownerReveal['entity-root-entities-insights-tab'],
  component: RootEntitiesContent,
  name: 'Root Entities',
  icon: List,
  linkTooltipFile: 'root-entities',
  supportedResultTypes: ['owner'],
}
